<template>
  <div class="navItemWrapper">
    <el-menu-item
      :disabled="disabled"
      class="navItem"
      :class="{ active: selected }"
      index="records-messages"
    >
      <span class="item">
        <md-icon name="question_answer" />
        <span>{{ $t('records.nav.messages') }}</span>
      </span>
    </el-menu-item>
  </div>
</template>

<script>
import NavRecordsInterface from './NavRecordsInterface'

export default {
  name: "NavRecordsMessages",
  extends: NavRecordsInterface
}
</script>

<style lang="scss" scoped>
</style>